module.exports = {
  google: {
    API_KEY: "",
    CLIENT_ID:"",
    SECRET: "",
    serverpass  : "Xyvr7b!VEcq@?k8L"
  },
devServer : {
  historyApiFallback : true
},

  facebook: {
    APP_ID: "",
  },
}
